import { useEffect, useState } from "react";

export const useMountTransition = (
  isMounted: boolean,
  unmountDelay: number,
): boolean => {
  const [hasTransitionedIn, setHasTransitionedIn] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    if (isMounted && !hasTransitionedIn) {
      timeoutId = setTimeout(() => setHasTransitionedIn(true), 0);
    } else if (!isMounted && hasTransitionedIn) {
      timeoutId = setTimeout(() => setHasTransitionedIn(false), unmountDelay);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [isMounted, hasTransitionedIn]);

  return hasTransitionedIn;
};
